import React from 'react';

/**
 * Give a link to the Amiko Home logo in svg format
 *
 * @returns {XML}
 * @constructor
 */
export const Logo = () => {
	return (
		<svg>
			<use xlinkHref="#amiko-logo"/>
		</svg>
	);
};

/**
 * Give a link to the header background svg
 *
 * @returns {XML}
 * @constructor
 */
export const HeaderBackground = ( { location, localizePath, hasSlider } ) => {
	const className = location.pathname === localizePath('/') && hasSlider ? "header-bg" : "header-bg header-bg--sm";
	return (
		<svg className={className} viewBox="0 0 1920 400" preserveAspectRatio="none">
			<polygon points="0,0 0,300 960,350 1920,300 1920,0" fill="url(#header-bg-gradient)"/>
			<defs>
				<linearGradient id="header-bg-gradient"  x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(90)">
					<stop className="header-bg-gradient-stop0" offset="0%"/>
					<stop className="header-bg-gradient-stop100" offset="100%"/>
				</linearGradient>
			</defs>
		</svg>
	);
};

/**
 * Give a link to the Error 404 sign in svg format
 *
 * @returns {XML}
 * @constructor
 */
export const Error404 = () => {
	return (
		<svg>
			<use xlinkHref="#error-404"/>
		</svg>
	);
};

/**
 * Give all the svgs
 *
 * @returns {XML}
 * @constructor
 */
const SVG = () => {
	const hiddenStyle = {
		display: "none",
		overflow: "hidden",
		width: 0,
		height: 0,
		visibility: "hidden"
	};
	return(
		<div style={hiddenStyle}>
			<svg xmlns="http://www.w3.org/2000/svg">
				<linearGradient id="amiko-gradient" gradientUnits="userSpaceOnUse" x1="38.2308" y1="-6.8716" x2="786.5633" y2="320.3877" gradientTransform="matrix(1 0 0 -1 0 246.3897)">
					<stop  offset="0" style={{stopColor:'#3AAA37'}}/>
					<stop  offset="0.4365" style={{stopColor:'#95C11F'}}/>
					<stop  offset="0.5047" style={{stopColor:'#9BC325'}}/>
					<stop  offset="0.5936" style={{stopColor:'#ACCA34'}}/>
					<stop  offset="0.6939" style={{stopColor:'#C5D54D'}}/>
					<stop  offset="0.8018" style={{stopColor:'#E4E573'}}/>
					<stop  offset="0.9022" style={{stopColor:'#FFF59B'}}/>
				</linearGradient>
				<symbol id="amiko-logo" viewBox="0 0 586.8 246.6">
					<path className="amiko-logo-path" d="M152.6,79.5H231c5.8,0,11.1,0.9,15.9,2.8c4.9,1.9,8.9,4.4,12.4,7.7c3.5,3.4,6,7.2,8,11.8
						c1.9,4.6,2.8,9.6,2.8,15.1v44.2h-19v-40.9c0-14.4-6.7-21.6-20.1-21.6h-59.4v62.4h-19L152.6,79.5L152.6,79.5z M200.6,108.7h19v52.3
						h-19V108.7z M284.9,79.5v16.1v65.5h19V95.6V79.5H284.9z M337.8,161.1h-19V79.5h19v31.7h29.6l26.6-31.7h23.8L389.9,112
						c9.3,1.9,16.5,6.2,21.5,12.8c5.1,6.7,7.5,15.7,7.5,26.9v9.4h-19v-9.9c0-14.4-6.8-21.7-20.4-21.7h-41.7V161.1z M535.8,79.5v41.1
						c0,6.4-0.8,12.1-2.6,17.1c-1.7,5-4.3,9.3-7.5,12.8c-3.4,3.5-7.4,6.2-12.3,8c-4.9,1.9-10.4,2.8-16.6,2.8H432v-41.1
						c0-6.2,0.9-11.8,2.7-16.8s4.3-9.3,7.7-12.9c3.4-3.5,7.4-6.3,12.2-8.1c4.9-1.9,10.3-2.9,16.6-2.9h64.6V79.5z M516.8,98.6h-45.4
						c-3.9,0-7.2,0.3-9.9,1c-2.7,0.7-4.8,1.9-6.3,3.6s-2.7,3.9-3.4,6.7c-0.7,2.8-1,6.3-1,10.6v21.2h45.4c3.8,0,7.1-0.3,9.6-1
						c2.6-0.7,4.6-1.9,6.3-3.5c1.6-1.6,2.8-3.8,3.5-6.6c0.7-2.8,1-6.3,1-10.6V98.6H516.8z M138.4,161.1h-19v-31.6H55.8v31.6h-19v-41
						c0-6.4,0.8-12.1,2.6-17.1c1.7-5,4.3-9.3,7.5-12.8c3.4-3.5,7.4-6.2,12.3-8c4.9-1.9,10.3-2.8,16.6-2.8h62.7V161.1z M119.4,98.6H84.9
						c-5.7,0-10.2,0.3-13.8,0.9c-3.5,0.6-6.3,1.5-8.2,2.7s-3.4,2.4-4.2,4.1c-0.8,1.6-1.5,3.4-1.9,5.2h62.4V98.6H119.4z M504.8,106.5H476
						c-2.4,0-4.5,0.2-6.3,0.7c-1.6,0.5-3,1.2-3.9,2.3c-0.9,1-1.6,2.4-2.1,4.3c-0.5,1.7-0.7,3.9-0.7,6.6v13.5h28.8c2.4,0,4.5-0.2,6.2-0.6
						c1.6-0.5,3-1.2,3.9-2.2c1-1,1.7-2.4,2.2-4.2s0.7-3.9,0.7-6.6V106.5z M550.4,79.4c0,3.1-2.4,5.6-5.5,5.6c-3,0-5.5-2.4-5.5-5.6
						c0-3.1,2.4-5.6,5.5-5.6C547.9,73.9,550.4,76.4,550.4,79.4z M540.9,79.4c0,2.4,1.7,4.4,4.2,4.4c2.3,0,4.1-2,4.1-4.4
						c0-2.4-1.7-4.4-4.1-4.4C542.6,75,540.9,77.1,540.9,79.4z M544.1,82.3h-1.3v-5.6c0.5-0.1,1.2-0.1,2.1-0.1c1,0,1.4,0.1,1.9,0.5
						c0.3,0.2,0.6,0.6,0.6,1.2c0,0.7-0.5,1.2-1,1.3v0.1c0.5,0.1,0.8,0.6,0.9,1.4s0.3,1.2,0.3,1.4h-1.3c-0.1-0.2-0.2-0.7-0.5-1.4
						c-0.1-0.6-0.5-0.8-1-0.8h-0.6v2.1H544.1z M544.1,79.1h0.6c0.7,0,1.3-0.2,1.3-0.8c0-0.5-0.3-0.8-1.2-0.8c-0.3,0-0.6,0-0.7,0.1V79.1z
						 M285.9,0L36.4,42.5V53L286,14.6L535.6,53V42.5L285.9,0z M36.7,187.4h9.1V211h79v-23.6h9.1v59.2h-9.1v-27.2h-79v27.2h-9.1V187.4z
						 M360.6,235.7h0.1l45-48.3h13.9v59.2h-9.1v-50.4h-0.2L363,246.6h-4.8l-47.5-50.4h-0.2v50.4h-9.1v-59.2h13.9L360.6,235.7z
						 M459.2,238.5h78.1v8.1H450v-59.2h85.8v8.1h-76.6v15.7h67.5v7.9h-67.5L459.2,238.5L459.2,238.5z M255.6,187.4h-75.8
						c-8.6,0-15.6,7-15.6,15.6v27.9c0,8.6,7,15.6,15.6,15.6h75.8c8.6,0,15.6-7,15.6-15.6V203C271.3,194.5,264.3,187.4,255.6,187.4z
						 M262.2,230c0,4.2-3.4,7.5-7.5,7.5h-73.9c-4.2,0-7.5-3.4-7.5-7.5v-26c0-4.2,3.4-7.5,7.5-7.5h73.9c4.2,0,7.5,3.4,7.5,7.5V230z"/>
				</symbol>
				<symbol id="error-404" viewBox="0 0 383.93 512">
					<path d="M362.09,164H149.91a12,12,0,1,0,0,24H362.09A12,12,0,0,0,362.09,164Z" transform="translate(-64.03 0)"/>
					<path d="M362.09,236.35H149.91a12,12,0,1,0,0,24H362.09A12,12,0,0,0,362.09,236.35Z" transform="translate(-64.03 0)"/>
					<path d="M447.94,103.44a12,12,0,0,0-3.49-8.16L352.76,3.59A12,12,0,0,0,344.21,0H89.29A25.28,25.28,0,0,0,64,25.25V324.6c0,0.11,0,.21,0,0.31a17.86,17.86,0,0,0,8.48,14.78l41.35,25.67a41.71,41.71,0,0,0,44.25,0l28.38-17.61a17.88,17.88,0,0,1,19,0l28.38,17.61a41.7,41.7,0,0,0,44.25,0l28.38-17.61a17.88,17.88,0,0,1,19,0l28.38,17.61a41.7,41.7,0,0,0,44.25,0l41.36-25.67a17.86,17.86,0,0,0,8.48-14.78c0-.1,0-0.21,0-0.31V103.76A3.09,3.09,0,0,0,447.94,103.44Zm-91.74-62.5h0L407,91.77H357.46a1.26,1.26,0,0,1-1.26-1.26V40.94h0ZM424,321.08L385.46,345a17.88,17.88,0,0,1-19,0l-28.38-17.62a41.71,41.71,0,0,0-44.25,0L265.48,345a17.88,17.88,0,0,1-19,0l-28.38-17.61a41.7,41.7,0,0,0-44.25,0L145.5,345a17.88,17.88,0,0,1-19,0L88,321.08V25.25A1.27,1.27,0,0,1,89.29,24H332.22V90.51a25.27,25.27,0,0,0,25.24,25.24H424V321.08Z" transform="translate(-64.03 0)"/>
					<path d="M448,395.95s0-.06,0-0.09,0-.06,0-0.09a18,18,0,0,0-27.46-15.28l-35.44,22a17.11,17.11,0,0,1-18.15,0l-29.2-18.12a40.93,40.93,0,0,0-43.44,0l-29.2,18.12a17.11,17.11,0,0,1-18.15,0l-29.2-18.12a40.94,40.94,0,0,0-43.44,0l-29.2,18.12a17.11,17.11,0,0,1-18.15,0l-35.44-22A18,18,0,0,0,64,395.76s0,0.06,0,.09,0,0.06,0,.09v90.8A25.28,25.28,0,0,0,89.28,512H422.71A25.28,25.28,0,0,0,448,486.75v-90.8ZM422.72,488H89.29A1.27,1.27,0,0,1,88,486.75V406.54l26.28,16.31a41,41,0,0,0,43.44,0l29.19-18.12a17.11,17.11,0,0,1,18.15,0l29.2,18.12a40.94,40.94,0,0,0,43.44,0l29.2-18.12a17.11,17.11,0,0,1,18.15,0l29.2,18.12a40.94,40.94,0,0,0,43.44,0L424,406.54v80.21A1.27,1.27,0,0,1,422.72,488Z" transform="translate(-64.03 0)"/>
				</symbol>
			</svg>
		</div>
	);
};

export default SVG;


// WEBPACK FOOTER //
// ./src/components/common/SVG.js